import React from 'react';
import GroupForm from '../components/GroupForm';
import { useGroupList } from '../hooks/useGroupList';

const GroupAdd = () => {
  const { addGroup } = useGroupList();

  return <GroupForm addGroup={addGroup} />;
};

export default GroupAdd;
